import React, { useState } from "react";
import { Input, Box, Flex } from "theme-ui";
import { ListItem } from "./ListItem";
import { useCombobox } from "downshift";
import { ImSearch } from "react-icons/im";
import { Device } from "../models";

const menuStyles = {
  width: "100%",
  overflowY: "auto",
  flex: "1 1 0%",
  minHeight: 0,
  padding: 0,
  listStyle: "none",
  position: "relative",
};

const comboboxStyles = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  flexShrink: 0,
};

export const SearchBar: React.FunctionComponent<{
  onClick: (device: Device) => void;
  items: Device[];
  isMobile: boolean;
}> = ({ onClick, items, isMobile }) => {
  const [inputItems, setInputItems] = useState(items);
  const {
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps,
  } = useCombobox({
    itemToString: (item) => (item ? item.name : ""),
    items: inputItems,
    defaultIsOpen: true,
    onInputValueChange: ({ inputValue }) => {
      setInputItems(
        items.filter((item) =>
          item.name
            .toLowerCase()
            .startsWith(inputValue ? inputValue.toLowerCase() : "")
        )
      );
    },
  });

  return (
    <Flex
      sx={{
        width: "100%",
        flex: "1 1 0%",
        minHeight: 0,
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box style={comboboxStyles} mt={3} px={4} {...getComboboxProps()}>
        <div className="input-wrapper">
          <ImSearch
            className="input-icon"
            color="#6c7684"
            style={{ fontSize: 14 }}
          />
          <Input
            {...getInputProps()}
            placeholder="Search providers"
            sx={{
              border: "1px solid",
              borderColor: "border",
              borderRadius: "10px",
              fontSize: 2,
              py: "11px",
              width: "100%",
              paddingLeft: "38px",
              color: "text",
              bg: "background",
              outline: "none",
              boxShadow: "small",
              transition: "border-color 0.15s ease, box-shadow 0.15s ease",
              "::placeholder": { color: "textMuted" },
              ":focus": {
                borderColor: "primary",
                boxShadow: "0 0 0 3px rgba(17, 17, 17, 0.2)",
              },
            }}
          />
        </div>
      </Box>
      <ul
        {...getMenuProps()}
        style={{
          ...menuStyles,
          paddingBottom: "max(16px, env(safe-area-inset-bottom))",
          marginBlockStart: "0.5em",
          marginBlockEnd: 0,
        }}
      >
        {inputItems
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((item, index) => (
            <ListItem
              key={index}
              getItemProps={getItemProps}
              item={item}
              index={index}
              highlightedIndex={highlightedIndex}
              onClick={onClick}
            />
          ))}
      </ul>
    </Flex>
  );
};
